// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"83b8f5ab","177":"df515257","288":"8e26e5ea","480":"676699e0","972":"73d681a1"}[chunkId] + ".chunk.js";
};